<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Contratos</h1>
    </div>
    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold m-0"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold mr-0"
                  v-b-tooltip.hover
                  title="Descargar"
                  @click="downloadReport()"
                >
                  <i class="ri-download-2-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>

              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold ml-0"
                v-b-tooltip.hover
                title="Descargar"
                @click="downloadReport()"
              >
                <i class="ri-download-2-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto md-flex-1 d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por número de documento o nombres y apellidos"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />

              <div class="text-right mt-2 mt-md-0">
                <b-button
                  :to="{ name: 'contracts-bulk-upload' }"
                  variant="none"
                  class="button button-light ml-md-2"
                ><i class="ri-upload-2-line mr-1"></i>Cargar</b-button>
                <b-button
                  :to="{ name: 'contracts-create' }"
                  variant="none"
                  class="button button-primary ml-md-2"
                  >Agregar</b-button
                >
              </div>
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>
      <div>
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Número de Contrato</span>
            </div>

            <div>
              <span>Nombre del colaborador</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.number }}</span>
                  <i v-if="o.hasSignedDocument" class="ri-file-check-line text-success ml-1" style="font-size: 14px;"></i>
                </div>

                <div>
                  <span>{{ o.fullName }}</span>
                </div>
                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{ name: 'contracts-edit', params: { id: o.code } }"
                  class="mx-3"
                >
                  Editar
                </router-link>

                <a href="" @click.prevent="openCeaseModal(o)" v-if="canCease(o)">
                  Cesar
                </a>

                <a href="" @click.prevent="downloadDocument(o.id)" class="mx-3">
                  Generar documento
                </a>
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Código:</span
                    >
                    <span>{{ o.employeeCode || "-" }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Empresa:</span
                    >
                    <span>{{ o.company || "-" }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Área:</span
                    >
                    <span>{{ o.area || "-" }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Fecha de Inicio del Contrato:</span
                    >
                    <span v-local-date="o.startDate"></span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Tiempo de Contrato:</span
                    >
                    <span>{{ getContractType(o.contractType) }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Sueldo Base:</span
                    >
                    <span
                      v-decimal:pen="o.baseSalary"
                      v-if="o.baseSalary"
                    ></span>
                    <span v-else>-</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Sueldo Total:</span
                    >
                    <span
                      v-decimal:pen="o.totalSalary"
                      v-if="o.totalSalary"
                    ></span>
                    <span v-else>-</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Estado:</span
                    >
                    <span :class="`badge ${getContractStatus(o).color}`">{{
                      getContractStatus(o).label
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>
                Número <br />
                de Contrato
              </th>
              <th>
                Código de <br />
                Colaborador
              </th>
              <th>
                Nombre <br />
                del Colaborador
              </th>
              <th>Empresa</th>
              <th>Área</th>
              <th>Canal</th>
              <th>Línea de gasto</th>
              <th>
                Fecha de <br />
                Inicio del Contrato
              </th>
              <th>
                Tiempo de <br />
                Contrato
              </th>
              <th>Sueldo Base</th>
              <th>Sueldo Total</th>
              <th>Estado</th>
              <th class="pr-md-3">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="cell-center pl-3">
                {{ o.number }}
                <i v-if="o.hasSignedDocument" class="ri-file-check-line text-success ml-1" v-b-tooltip.hover title="Contrato firmado adjunto" style="font-size: 14px;"></i>
              </td>
              <td class="cell-center pl-3">{{ o.employeeCode || "-" }}</td>
              <td class="pl-3 text-left">{{ o.fullName || "-" }}</td>
              <td class="pl-3">{{ o.company || "-" }}</td>
              <td class="pl-3">{{ o.area || "-" }}</td>
              <td class="pl-3">{{ o.channelName || "-" }}</td>
              <td class="pl-3">{{ o.expenseLineName || "-" }}</td>
              <td class="cell-center pl-3" v-local-date="o.startDate"></td>
              <td class="cell-center pl-3">
                {{ getContractType(o.contractType) }}
              </td>
              <td class="cell-center pl-3">
                <span v-decimal:pen="o.baseSalary" v-if="o.baseSalary"></span>
                <span v-else>-</span>
              </td>
              <td class="cell-center pl-3">
                <span v-decimal:pen="o.totalSalary" v-if="o.totalSalary"></span>
                <span v-else>-</span>
              </td>
              <td class="cell-center pl-md-2">
                <span :class="`badge ${getContractStatus(o).color}`">{{
                  getContractStatus(o).label
                }}</span>
              </td>
              <td class="cell-center d_option pr-md-2 position-relative">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem
                      text="Editar"
                      :to="{
                        name: 'contracts-edit',
                        params: { id: o.id },
                      }"
                    />
                    <DropdownItem
                      text="Cesar"
                      @click="openCeaseModal(o)"
                      v-if="canCease(o)"
                    />
                    <DropdownItem
                      text="Generar documento"
                      @click="downloadDocument(o.id)"
                    />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
          v-if="list.length"
        />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron resultados.</p>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-cease"
      title="Cesar contrato"
      ok-title="Cesar"
      ok-variant="danger"
      cancel-title="Cancelar"
      :ok-disabled="!ceaseForm.terminationDate || !ceaseForm.terminationReason"
      @ok="ceaseContract"
    >
      <div v-if="selectedOption">
        <p class="mb-3">
          Vas a cesar el contrato <strong>{{ selectedOption.number }}</strong> de
          <strong>{{ selectedOption.fullName }}</strong>. Esta acción es irreversible.
        </p>

        <div class="form-group">
          <label class="font-weight-medium">Fecha de cese <span class="text-danger">*</span></label>
          <FormDatepicker v-model="ceaseForm.terminationDate" :max="todayIso()" />
        </div>

        <div class="form-group">
          <label class="font-weight-medium">Motivo <span class="text-danger">*</span></label>
          <FormSelect
            v-model="ceaseForm.terminationReason"
            :items="reasonOptions"
            defaultOption="Seleccionar motivo"
          />
        </div>

        <div class="form-group">
          <label class="font-weight-medium">Observaciones</label>
          <b-form-textarea v-model="ceaseForm.terminationNotes" rows="3" max-rows="6" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  Constants,
  Util,
  Alert,
  FilterMenu,
  FilterMixin,
  PaginationMixin,
  DropdownTable,
  DropdownItem,
  SearchBar,
  FormDatepicker,
  FormSelect,
} from "wize-admin";

import { Constants as LocalConstants } from "@/core/utils";
import { ContractsService, AreaService, CompanyService } from "@/core/services";
import fileDownload from "js-file-download";

export default {
  mixins: [PaginationMixin, FilterMixin],
  components: {
    SearchBar,
    DropdownTable,
    DropdownItem,
    FilterMenu,
    FormDatepicker,
    FormSelect,
  },
  data() {
    return {
      list: [],
      tooltipType: null,
      selectedOption: null,
      ceaseForm: {
        terminationDate: null,
        terminationReason: null,
        terminationNotes: '',
      },
      reasonOptions: Object.values(LocalConstants.TerminationReason),
      filterOptions: [
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.ContractStatus.ACTIVE,
            LocalConstants.ContractStatus.EXPIRED,
            LocalConstants.ContractStatus.CEASED,
          ],
        },
        {
          label: "Fecha de inicio del contrato",
          key: "contractInitiation",
          type: Constants.TypeFilters.DATE,
          isRange: true,
        },
        {
          label: "Fecha de término del contrato",
          key: "contractFinish",
          type: Constants.TypeFilters.DATE,
          isRange: true,
        },
        {
          label: "Empresa",
          key: "companyIds",
          type: Constants.TypeFilters.MULTIPLE,
          options: [],
        },
        {
          label: "Área",
          key: "areaIds",
          type: Constants.TypeFilters.MULTIPLE,
          options: [],
        },
        {
          label: "Tipo de contrato",
          key: "contractType",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.ContractDurationOptions.ONE_MONTH,
            LocalConstants.ContractDurationOptions.THREE_MONTHS,
            LocalConstants.ContractDurationOptions.SIX_MONTHS,
            LocalConstants.ContractDurationOptions.ONE_YEAR,
            LocalConstants.ContractDurationOptions.INDEFINITE
          ],
        },
      ],
    };
  },
  methods: {
    async getAreas() {
      try {
        this.$store.dispatch("app/loading", true);

        const resp = (await AreaService.listAll()).payload;

        let optionItem = this.filterOptions.find((item) => item.key === "areaIds");

        optionItem.options = resp.map((item) => {
          return {
            key: item.id,
            label: `${item.description}`,
          };
        });
      } catch (ex) {
        Alert.error(ex.errors.message);
        console.error(ex);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async getCompanies() {
      try {
        this.$store.dispatch("app/loading", true);

        const resp = (await CompanyService.listAll()).payload;

        let optionItem = this.filterOptions.find((item) => item.key === "companyIds");

        optionItem.options = resp.map((item) => {
          return {
            key: item.id,
            label: `${item.name}`,
          };
        });
      } catch (ex) {
        Alert.error(ex.errors.message);
        console.error(ex);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);
        const params = {
          page: this.page - 1,
          size: this.pageSize,
          sort: "id",
        };
        const data = { search: this.search, ...this.filters };
        const response = await ContractsService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getStatus(key) {
      let keyInt = parseInt(key);
      return Util.searchValue(keyInt, LocalConstants.ContractStatus) || { label: '-', action: '' };
    },
    getContractStatus(contract) {
      switch (contract.displayStatus) {
        case 'POR_VENCER': return { label: 'POR VENCER', color: 'badge-yellow' }
        case 'VIGENTE':    return { label: 'VIGENTE',    color: 'badge-green' }
        case 'VENCIDO':    return { label: 'VENCIDO',    color: 'badge-warning' }
        case 'CESADO':     return { label: 'CESADO',     color: 'badge-secondary' }
        default:           return { label: '-',          color: 'badge-gray' }
      }
    },
    getContractType(key) {
      const item = Util.searchValue(parseInt(key), LocalConstants.ContractDurationOptions);
      return item ? item.label : "-";
    },
    canCease(o) {
      return o && parseInt(o.status) === LocalConstants.ContractStatus.ACTIVE.key;
    },
    openCeaseModal(o) {
      this.selectedOption = o;
      this.ceaseForm = {
        terminationDate: this.todayIso(),
        terminationReason: null,
        terminationNotes: '',
      }
      this.$bvModal.show('modal-cease');
    },
    todayIso() {
      const d = new Date();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${d.getFullYear()}-${m}-${day}`;
    },
    async ceaseContract(bvModalEvt) {
      if (bvModalEvt) bvModalEvt.preventDefault();
      if (!this.selectedOption) return;
      if (!this.ceaseForm.terminationDate || !this.ceaseForm.terminationReason) {
        Alert.error('Completa la fecha y el motivo de cese');
        return;
      }
      try {
        await this.$store.dispatch("app/loading", true);
        await ContractsService.cease(this.selectedOption.id, {
          terminationDate: this.ceaseForm.terminationDate,
          terminationReason: this.ceaseForm.terminationReason,
          terminationNotes: this.ceaseForm.terminationNotes || null,
        });
        this.$bvModal.hide('modal-cease');
        await this.loadData();
        Alert.success('Contrato cesado correctamente');
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors ? ex.errors.message : 'Error al cesar el contrato');
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async downloadDocument(contractId) {
      try {
        await this.$store.dispatch("app/loading", true);
        const response = await ContractsService.downloadDocument(contractId);
        fileDownload(response.data, Util.getFileName(response));
      } catch (error) {
        console.error(error);
        Alert.error("Error al generar el documento del contrato");
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async downloadReport() {
      try {
        await this.$store.dispatch("app/loading", true);
        const data = { search: this.search, ...this.filters };
        const response = await ContractsService.download(data);
        fileDownload(response.data, Util.getFileName(response));
      } catch (error) {
        console.error(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
  },
  async created() {
    await this.getCompanies()
    await this.getAreas()
    await this.loadData(this.page, this.pageSize);
  },
};
</script>

<style lang="stylus">
@import '../Styles/supplier-list';
</style>
